export const Tab = _props => null;